export enum actionTypesReports {
  ListOfStockReport = "stockReportList",
  ListOfReserveStockReport = "reserveStockReportList",
  LastRefreshStockReport = "lastRefreshStockReport",
  ListOfPmxInventory = "pmxInventoryList",
  ListOfPmxInventoryDetail = "pmxInventoryDetailList",
  ListOfProductionStockReport = "productionStockReportList",
  ListOfRawMaterialOverviewStockReport = "rawMaterialOverviewStockReportList",
  ListOfRawMaterialStockReport = "rawMaterialStockReportList",
  ListOfProductReport = "productReportList",
  LastRefreshProductReport = "lastRefreshProductReport",
  ListOfCustomerStatus = "customerStatusList",
  ListOfCustomerOrder = "customerOrderList",
  ListOfDelivery = "deliveryList",
  ListOfUsageL36M2 = "usageL36M2List",
  ListOfUsageL36M2V2 = "usageL36M2V2List",
  ListOfValueL36M = "valueL36MList",
  ListOfInvoiceDNDetail = "invoiceDNDetailList",
  SetUsageL36M2V2HiddenColumns = "setUsageL36M2V2HiddenColumns",
  SetValueL36MHiddenColumns = "setValueL36MHiddenColumns",
  SetInvoiceDNDetailHiddenColumns = "setInvoiceDNDetailHiddenColumns",
  SetUsageL36M2V2ColumnOrder = "setUsageL36M2V2ColumnOrder",
  SetValueL36MColumnOrder = "setValueL36MColumnOrder",
  SetInvoiceDNDetailColumnOrder = "setInvoiceDNDetailColumnOrder",
}
